/** Convertit une URL interne (/path#hash) en prop `to` React Router. */
export function toRouterPath(url) {
  if (!url || typeof url !== 'string' || !url.startsWith('/')) {
    return url;
  }
  const hashIndex = url.indexOf('#');
  if (hashIndex === -1) {
    return url;
  }
  const pathname = url.slice(0, hashIndex) || '/';
  const hash = url.slice(hashIndex);
  return { pathname, hash };
}
